import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page game-detail-page"
}
const _hoisted_2 = {
  key: 0,
  class: "dev-ribbon"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "glass-card about-card"
}
const _hoisted_6 = { class: "page-eyebrow" }
const _hoisted_7 = { class: "about-text" }
const _hoisted_8 = { class: "game-actions-row" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "promo-note"
}
const _hoisted_11 = {
  key: 2,
  class: "glass-card spec-card"
}
const _hoisted_12 = { class: "page-eyebrow" }
const _hoisted_13 = { class: "spec-grid" }
const _hoisted_14 = { class: "spec-value" }
const _hoisted_15 = { class: "spec-label" }
const _hoisted_16 = {
  key: 1,
  class: "page game-detail-page"
}
const _hoisted_17 = { class: "not-found" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Logo),
    (_ctx.gameData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "back-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("← " + _toDisplayString(_ctx.jsonData.gamePageBack), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "game-hero",
            style: _normalizeStyle({'background-image': 'url(' + _ctx.heroImage + ')'})
          }, [
            (_ctx.isInDev)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "in development"))
              : _createCommentVNode("", true),
            (_ctx.heroVideoSrc)
              ? (_openBlock(), _createElementBlock("video", {
                  key: 1,
                  ref: "heroVideo",
                  class: "game-hero-video",
                  src: _ctx.heroVideoSrc,
                  autoplay: "",
                  muted: "",
                  loop: "",
                  playsinline: ""
                }, null, 8, _hoisted_3))
              : (_ctx.heroInfoImageSrc)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    class: "game-hero-video",
                    src: _ctx.heroInfoImageSrc,
                    alt: ""
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
          ], 4),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.jsonData.gamePageAbout), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.description), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "action-btn action-btn--demo",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playDemo && _ctx.playDemo(...args)))
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "action-icon" }, "▶", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.jsonData.gamePagePlayDemo), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "action-btn action-btn--coins",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.playInCoins && _ctx.playInCoins(...args)))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "action-icon" }, "◎", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.jsonData.gamePagePlayCoins), 1)
            ]),
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "action-btn action-btn--promo",
                  href: _ctx.gameData.promoPack,
                  download: ""
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "action-icon" }, "⭳", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.jsonData.gamePagePromoPack), 1)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.jsonData.gamePagePromoPackNote), 1))
            : _createCommentVNode("", true),
          (_ctx.specRows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.jsonData.gamePageSpecEyebrow), 1),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specRows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "spec-tile",
                      key: row.label
                    }, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(row.value), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(row.label), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.jsonData.gamePageNotFound), 1),
          _createVNode(_component_router_link, {
            to: "/",
            class: "back-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("← " + _toDisplayString(_ctx.jsonData.gamePageBack), 1)
            ]),
            _: 1
          })
        ]))
  ], 64))
}